export default __webpack_public_path__ + "1351621fe32de9d0c2b56d4a203b14e5.png";